import React, { useEffect, useState } from "react";
import DiscardDraftModal from "../mjpModals/DiscardDraftModal";
import { JobsDataType } from "../../types/api-response";
import { folderPagePath, formatDate } from "../../utils";
import getMappedJobType from "../common/utils/getMappedJobType";
import CommonEmptyState from "./CommonEmptyState";
import { JOB_TITLE_CHAR_LIMIT_ELLIPSIS } from "../../constants/tabs";
import { useAppSelector } from "../../redux/store";

interface Props {
  jobsData: JobsDataType[] | undefined;
}

const Drafts = ({ jobsData }: Props) => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    id: 0,
    title: "",
  });
  
  if ((jobsData || []).length === 0) {
    return <CommonEmptyState text="You don’t have any job in your draft!"/>;
  }
  
  return (
    <div className="search-result_container">
      {(jobsData || []).map((job, index) => {
        const { jobId, title, jobType, draftedDate, jobPostingType } = job || {};
        return (
          <div 
           id={String(jobId)} 
           className={`search-result_card ${index===0 ? 'first-rounded' : ''}`}
           >
            <div className="search-result_card_rt">
              <div className="search-result_title-container">
                <div className="search-result_card_row">
                  <span 
                  className={`main_title clickable${title?.length > (JOB_TITLE_CHAR_LIMIT_ELLIPSIS + 20) ? " allow_ellipsis":""}`}
                  role="button"
                  onClick={()=>window.open(
                    `${window.location.origin}/edge/${folderPagePath}?folderID=${jobId}&autoMatch=false`,
                    "_blank"
                    )}
                  >{title}</span>
                  <span className="faded subtitle">
                  ({`${jobPostingType=='SJS' ? getMappedJobType('SOCIAL') : getMappedJobType(jobType?.name)}`})
                    </span>
                </div>
              </div>

              <div className="horizontal_seperator" />

              <div className="search-result_card_row">
                <div className="folder_table_container">
                  <div className="folder_table_item">
                    <div className="folder_column faded">Saved on</div>
                    <div className="drafts_views">
                      {formatDate(draftedDate)}
                    </div>
                  </div>
                </div>

                <div className="drafts_cta-container">
                  <button
                    className="drafts_cta_discard"
                    onClick={() =>
                      setModalState({ isOpen: true, id: jobId, title: title })
                    }
                  >
                    Discard draft
                  </button>
                  <button 
                  className="foundit-button secondaryButton drafts_cta"
                  onClick={()=>window.open(
                    `${window.location.origin}/edge/jobposting/new-job-posting/edit/${jobId}`,
                    "_blank"
                    )}
                  >
                    Continue editing
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })}

      <DiscardDraftModal
        isOpen={modalState.isOpen}
        setIsOpen={() => setModalState({ isOpen: false, id: 0, title: "" })}
        id={modalState.id}
        draftName={modalState.title}
      />
    </div>
  );
};

export default Drafts;
